import { ApiResource } from "./apiResource";
import { ApiDataResponse } from "../apiClient";

export class PopupsApi extends ApiResource {
  async getPopupList() {
    return this.client.get<ApiDataResponse<any>>("/popups");
  }
}
